import { merge } from '../../helper';

import inArray from '../../general/inArray';

// ----------------------------------------------------------------------------

type TypeFilterDisabledData = Record<string, unknown> | unknown[];

interface IFilterDisabledConfig {
    type?: keyof HTMLOptionElement;
}

// ----------------------------------------------------------------------------

function filterDisabled(element: HTMLElement, data: TypeFilterDisabledData, config: IFilterDisabledConfig = {}): void {
    // Default Config
    const defConfig: IFilterDisabledConfig = {
        type: 'text',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Normalize supported data formats to a single comparable list
    const dataList = Array.isArray(data) ? data : Object.values(data);
    // Select which HTMLOptionElement property will be compared
    const optionKey = defConfig.type ?? 'text';

    // Get elements (list option)
    const listOption = element.querySelectorAll<HTMLOptionElement>('option');

    // Toggle disabled state based on whether the option value is allowed
    for (const elOption of listOption) {
        const optionValue = elOption[optionKey];

        elOption.disabled = !inArray(optionValue, dataList);
    }
}

// ----------------------------------------------------------------------------

export { filterDisabled };
